export default "__VITE_ASSET__DdX_iS9O__"